(() => {
  function syncShellCartBadges() {
    document.querySelectorAll('[data-ted-shell-cart]').forEach((el) => {
      const sizeEl = el.querySelector('xo-cart-size');
      const badge = el.querySelector('.shell-cart__count');
      if (!sizeEl || !badge) return;
      const count = parseInt(String(sizeEl.textContent || '0').replace(/[^\d]/g, ''), 10) || 0;
      el.classList.toggle('has-items', count > 0);
      if (count > 0) {
        badge.hidden = false;
        el.setAttribute(
          'aria-label',
          count === 1 ? 'Panier, 1 Ted' : 'Panier, ' + count + ' Teds'
        );
      } else {
        badge.hidden = true;
        el.setAttribute('aria-label', 'Panier');
      }
    });
  }

  syncShellCartBadges();

  const observer = new MutationObserver(syncShellCartBadges);
  document.querySelectorAll('[data-ted-shell-cart] xo-cart-size').forEach((node) => {
    observer.observe(node, { childList: true, characterData: true, subtree: true });
  });

  document.addEventListener('cart:updated', syncShellCartBadges);
  document.addEventListener('xo:cart:change', syncShellCartBadges);
  window.addEventListener('focus', syncShellCartBadges);

  // Poll briefly after load in case cart size hydrates late
  [400, 1200, 3000].forEach((ms) => setTimeout(syncShellCartBadges, ms));
})();
